import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoice = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "m14.16 16v-16h-12.32v16zm-1.232-1.232h-9.856v-13.536h9.856zm-2.464-10.896v-.688h-6.16v.688zm0 1.664v-.64h-6.16v.64z" }), /* @__PURE__ */ _jsx("path", { d: "m9.474 13.341c.52 0 .972-.118 1.299-.33l-.074-.787a2.076 2.076 0 0 1 -.995.268c-.779 0-1.246-.362-1.387-1.392h1.558l.104-.55h-1.707v-.41h1.84l.12-.574h-1.909c.148-.896.594-1.305 1.403-1.305.319 0 .564.055.816.165l.178-.841c-.297-.15-.72-.244-1.195-.244-1.224 0-1.989.81-2.174 2.225h-.579l.007.574h.535v.41h-.534l-.007.55h.586c.171 1.541.846 2.241 2.115 2.241z" })] })
});
export default SvgInvoice;
